import { useEffect, useState } from 'react'

import { Button } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import { Delete } from '@material-ui/icons'
import AddIcon from '@material-ui/icons/Add'
import SetState from 'Components/Hooks/SetState'
import BasicTable from 'Components/UI/Atoms/BasicTable'
import CustomButton from 'Components/UI/Atoms/CustomButton'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import ContentWithOutSubTabs from 'Components/UI/Molecules/ContentWithOutSubTabs'
import InputsWithoutValidate from 'Components/UI/Molecules/InputsWithoutValidate'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import useStyles from 'Components/UI/Organisms/Vehicles/Quotations/Edit/Fields/Home/styles'
import { SUCURSAL_ORIGEN } from 'Constants'
import { interfaces } from 'service/interfaces'

import { editFields } from '../Recibo/Add/Fields'

import { DataExtra, PaymentOrderFields } from './Add/fields'
import AddItem from './Add'

const PaymentOrder = ({
  data,
  onDataChange,
  edit,
  setRender,
  render,
  dataBefore,
  setData,
  closeCancel,
  permissions,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [formEdit, setFormEdit] = useState(data.paymentOrderDetails)
  const [selectedRow, setSelectedRow] = useState(null)
  const [tab, setTab] = useState(0)

  const createDismissableSnackbar = useCustomSnackbar()

  const origenEncontrado = SUCURSAL_ORIGEN.find(
    (sucursal) => sucursal.label === data.infoMain.origen
  )
  const empresaId = origenEncontrado ? origenEncontrado.id : null

  const {
    setOpen: setOpenPaymentDetail,
    state: paymentDetail,
    setClose: setClosePaymentDetail,
  } = SetState()

  const { state: add, setOpen: openAdd, setClose: closeAdd } = SetState()

  const classes = useStyles()

  async function orderInfo(id) {
    await interfaces.salesOrders.infoOneOrders(id).then((res) => {
      setData((prevData) => ({
        ...prevData,
        paymentOrder: res.data.paymentOrder,
        paymentOrderDetails: res.data.paymentOrderDetails,
        infoMain: res.data.infoMain,
      }))
      setFormEdit(res.data.paymentOrderDetails)
    })
  }

  useEffect(() => {
    const id = data.infoMain.id
    orderInfo(id)
    // eslint-disable-next-line
  }, [formEdit.length, data.infoMain.id])

  const createReceipt = async () => {
    const body = {
      empresa: empresaId,
      pedido: data.infoMain.id,
    }
    setIsLoading(true)
    await interfaces.salesPaymentOrders
      .create(body)
      .then((res) => {
        setRender(!render)
        orderInfo(data.infoMain.id)
        createDismissableSnackbar(res.data, {
          variant: 'success',
        })
      })
      .catch(() => {
        createDismissableSnackbar('Error', {
          variant: 'error',
        })
      })
    setIsLoading(false)
  }

  async function deleteDetail(id) {
    setIsLoading(true)
    const empresa = empresaId
    const orden = data.paymentOrder.id
    await interfaces.salesPaymentOrders.deletePaymentOrderItem(id, empresa, orden).then((res) => {
      createDismissableSnackbar(res.data, {
        variant: 'success',
      })
      deleteItem(id)
    })
    setIsLoading(false)
  }

  async function deleteReceipt() {
    const id = data.paymentOrder.id
    const empresa = empresaId
    setIsLoading(true)
    await interfaces.salesPaymentOrders.deletePaymentOrder(id, empresa).then((res) => {
      setRender(!render)
      orderInfo(data.infoMain.id)
      createDismissableSnackbar(res.data, {
        variant: 'success',
      })
    })
    setIsLoading(false)
  }

  const deleteItem = (id) => {
    let newItem = formEdit.filter((e) => e.id !== id)

    const deletedItem = formEdit.find((e) => e.id === id)
    const deletedImporte = deletedItem ? Number(deletedItem.importe) : 0

    setFormEdit(newItem)
    onDataChange(newItem)
    setData((prevData) => ({
      ...prevData,
      paymentOrderDetails: prevData.paymentOrderDetails.filter((detail) => detail.id !== id),
      paymentOrder: {
        ...prevData.paymentOrder,
        total: Math.trunc(prevData.paymentOrder.total || 0) - Math.trunc(deletedImporte),
        saldoResto: Math.trunc(prevData.paymentOrder.saldoResto || 0) + Math.trunc(deletedImporte),
      },
    }))
  }

  const handleChange = (name, value) => {
    setData({
      ...data,
      paymentOrder: {
        ...data.paymentOrder,
        [name]: value,
      },
    })
  }

  const iconDelete = (id, importe) => (
    <IconButton
      onClick={(event) => {
        event.stopPropagation()
        deleteDetail(id, importe)
      }}
      disabled={data.comprobantes.length > 0 || permissions.allowEditMin ? true : !edit}
      style={{ padding: '0px' }}
    >
      <Delete />
    </IconButton>
  )

  const getMetodoPagoNombre = (id) => {
    const metodo = dataBefore.data.metodosPago.find((metodo) => metodo.id === id)
    return metodo.tipo
  }

  const onClickRow = (index) => {
    if (!edit) return

    const selectedItem = formEdit.find((obj) => obj.id === index.id)

    setSelectedRow(selectedItem)
    setOpenPaymentDetail(true)
  }

  const editItem = async () => {
    if (!selectedRow.importe) {
      createDismissableSnackbar("El campos 'Importe' es obligatorio", {
        variant: 'error',
      })
      return
    }
    setIsLoading(true)
    const values = {
      id: selectedRow.id,
      empresa: empresaId,
      importe: Number(selectedRow.importe.replace(/[^0-9.,]+/g, '')),
      detalle: selectedRow.detalle,
      orden: data.paymentOrder.id,
      barcode: selectedRow.barcode,
      cupon: selectedRow.cupon,
      lote: selectedRow.lote,
      origen: selectedRow.origen,
      moneda: selectedRow.moneda,
    }

    await interfaces.salesPaymentOrders.editPaymentOrderItem(values).then((res) => {
      createDismissableSnackbar(res.data, {
        variant: 'success',
      })
      const previousRow = formEdit.find((row) => row.id === selectedRow.id)
      const previousImporte = previousRow ? Number(previousRow.importe) : 0
      const importeDifference = values.importe - previousImporte
      const updatedRows = formEdit.map((row) =>
        row.id === selectedRow.id ? { ...row, importe: values.importe } : row
      )
      orderInfo(data.infoMain.id)
      setFormEdit(updatedRows)
      setData((prevData) => ({
        ...prevData,
        paymentOrderDetails: updatedRows,
        paymentOrder: {
          ...prevData.paymentOrder,
          total: Math.trunc(prevData.paymentOrder.total || 0) + Math.trunc(importeDifference),
          saldoResto:
            Math.trunc(prevData.paymentOrder.saldoResto || 0) - Math.trunc(importeDifference),
        },
      }))
    })
    setClosePaymentDetail()
    setIsLoading(false)
    closeCancel()
  }

  const handleChangeItem = (name, value) => {
    setSelectedRow((prevInfo) => ({
      ...prevInfo,
      [name]: value,
    }))
  }

  const renderTabs = (index) => {
    switch (index) {
      case 0:
        return (
          <>
            <div style={{ margin: '2rem' }}>
              <InputsWithoutValidate
                key={data.paymentOrder ? data.paymentOrder.id : 'empty'}
                fields={PaymentOrderFields(data.paymentOrder, handleChange, edit, permissions)}
                spacing={2}
              />
            </div>

            <div style={{ display: 'flex', margin: '2rem', cursor: edit ? 'pointer' : '' }}>
              <BasicTable
                col={[
                  { title: 'Medio de pago', style: { width: '80px' } },
                  { title: 'Descripción', style: { width: '100px' } },
                  { title: 'Importe en pesos', style: { width: '80px' } },
                  { title: '', style: { width: '40px' } },
                  { title: '', style: { display: 'none' } },
                ]}
                size="small"
                rows={formEdit?.map((row) => {
                  return {
                    tipo: getMetodoPagoNombre(row.tipo),
                    descripcion: row.descripcion,
                    importe: `$${row.importe}`,
                    action: iconDelete(row.id, row.importe),
                    id: row.id,
                  }
                })}
                onClickRow={permissions.allowEditMin ? () => {} : onClickRow}
              />
              <div>
                <div className={classes.buttons}>
                  <Button
                    onClick={openAdd}
                    disabled={
                      data.comprobantes.length > 0 || permissions.allowEditMin
                        ? true
                        : data.paymentOrder.id
                          ? !edit
                          : true
                    }
                    color="primary"
                    variant="contained"
                    size="large"
                    style={{
                      marginLeft: '1rem',
                      height: '40px',
                    }}
                  >
                    <AddIcon />
                  </Button>

                  <Button
                    onClick={() => deleteReceipt()}
                    disabled={
                      data.comprobantes.length > 0 || permissions.allowEditMin
                        ? true
                        : data.paymentOrder.id
                          ? !edit
                          : true
                    }
                    variant="contained"
                    size="large"
                    style={{
                      backgroundColor:
                        data.comprobantes.length > 0 || permissions.allowEditMin
                          ? '#e0e0e0'
                          : data.paymentOrder.id
                            ? edit
                              ? '#f44336'
                              : '#e0e0e0'
                            : '#e0e0e0',
                      color:
                        data.comprobantes.length > 0 || permissions.allowEditMin
                          ? '#A9A9A9'
                          : data.paymentOrder.id
                            ? edit
                              ? '#FFF'
                              : '#A9A9A9'
                            : '#A9A9A9',
                      height: '40px',
                      marginRight: '1rem',
                      marginLeft: '1rem',
                    }}
                  >
                    <Delete />
                  </Button>

                  <CustomButton
                    color="primary"
                    buttonEnd
                    disabled={data.paymentOrder.id || permissions.allowEditMin ? true : !edit}
                    style={{
                      width: '120px',
                      height: '40px',
                    }}
                    text="Crear orden"
                    onClick={() => createReceipt()}
                  />
                </div>
                <div style={{ marginTop: '2rem' }}>
                  <InputsWithoutValidate
                    fields={DataExtra(data.paymentOrder, handleChange, edit)}
                    spacing={2}
                    justifyContent="flex-end"
                    key={data.paymentOrder ? data.paymentOrder.id : 'empty'}
                  />
                </div>
              </div>
            </div>
          </>
        )
      default:
        break
    }
  }

  const isSubmitDisabled = selectedRow
    ? Number(selectedRow.importe) <= 0 ||
      (selectedRow.tipo === 5
        ? !(
            selectedRow.verificacion &&
            [1, 2, 3, 4, 5, 6, 7, 8, 9].includes(Number(selectedRow.verificacion3))
          )
        : selectedRow.tipo === 1 || selectedRow.tipo === 4
          ? false
          : selectedRow.tipo === 2 || selectedRow.tipo === 3
            ? !selectedRow.origen || !selectedRow.lote || !selectedRow.cupon
            : selectedRow.tipo === 10
              ? !selectedRow.cupon || !selectedRow.origen || !selectedRow.barcode
              : selectedRow.tipo === 6 || selectedRow.tipo === 7
                ? !selectedRow.origen || !selectedRow.cupon
                : selectedRow.tipo === 8
                  ? !selectedRow.moneda || !selectedRow.cupon
                  : selectedRow.tipo === 51
                    ? !selectedRow.retencion
                    : true)
    : true

  return (
    <>
      <ContentWithOutSubTabs value={tab} setValue={setTab} children={renderTabs(tab)} />

      {add.suspense && (
        <AddItem
          data={dataBefore.data}
          open={openAdd}
          handleClose={closeAdd}
          render={render}
          setRender={setRender}
          dataInfo={data}
          setRows={setFormEdit}
          setData={setData}
        />
      )}

      <DialogComponent
        open={paymentDetail.open}
        title="Editar medio de pago"
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        handleclose={setClosePaymentDetail}
        widthLarge="500px"
        children={
          selectedRow ? (
            <InputsWithoutValidate
              fields={editFields(selectedRow, handleChangeItem, dataBefore.data)}
              spacing={2}
            />
          ) : null
        }
        actions={
          <CancelConfirmButtons
            disabledSubmit={isLoading || isSubmitDisabled}
            disabledCancel={isLoading}
            isLoading={isLoading}
            onClickSubmit={editItem}
            onClickCancel={setClosePaymentDetail}
          />
        }
      />
    </>
  )
}

export default PaymentOrder
